import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import {auth} from "./authmodule.js";
import {layout} from "./layoutmodule.js";
import {classStore} from "@/store/classStore";
import {employeeStore} from "@/store/employeeStore";
import {departmentStore} from "@/store/departmentStore";
import {studentStore} from "@/store/studentStore";
import {kidsStore} from "@/store/kidsStore";
import {finance2Module} from "@/store/finance2.module";
import {gradeModule} from "@/store/grade.module";
import {studentGroupModule} from "@/store/studentGroup.module";
import {groupExcelModule} from "@/store/GroupExcel.module";
import {dashBoardStore} from "@/store/dashBoardStore";
import {schoolStore} from "@/store/schoolStore";
import {employeeSalaryNew} from "@/store/employeeSalaryNew";
import {staticSalaryNew} from "@/store/staticSalaryNew";
import {commonDataStore} from "@/store/commonDataStore";
import {packageStore} from "@/store/packageStore";
import {parentStore} from "@/store/parentStore";
import {notificationNavbarStore} from "@/store/notificationNavbarStore";
import {schoolConfigStore} from "@/store/schoolConfigStore";
import {tuitionFeesStore} from "@/store/tuitionFeesStore";
import {sinvoiceCustomerConfigStore} from "@/store/sinvoiceCustomerConfigStore";
import {sinvoiceGoodsStore} from "@/store/sinvoiceGoodsStore";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        layout,
        gradeModule,
        classStore,
        employeeStore,
        departmentStore,
        studentStore,
        kidsStore,
        finance2Module,
        studentGroupModule,
        groupExcelModule,
        dashBoardStore,
        schoolStore,
        employeeSalaryNew,
        staticSalaryNew,
        commonDataStore,
        packageStore,
        parentStore,
        schoolConfigStore,
        notificationNavbarStore,
        tuitionFeesStore,
        sinvoiceCustomerConfigStore,
        sinvoiceGoodsStore
    },
    plugins: [
        createPersistedState({
            paths: [
                "tuitionFeesStore.dateSearch",
                "tuitionFeesStore.view",
                "tuitionFeesStore.category",
                "tuitionFeesStore.loadingBillPreview",
                "tuitionFeesStore.dataBill",
                "schoolConfigStore.configData",
                "finance2Module.view",
                "finance2Module.dataBillPreview",
                "finance2Module.billTableForOneKidPreview",
                "finance2Module.totalBillForOneKid",
                "finance2Module.isContainAllBillOneKid",
                "finance2Module.loadingOneKid",
                "finance2Module.loadingBillPreview",
                "finance2Module.dataSearch",
                "finance2Module.exportParamForOneKid",
                "finance2Module.idKidList",
                "finance2Module.firstMonth",
                "finance2Module.lastMonth",
                "groupExcelModule.dataBillPreview",
                "groupExcelModule.billTableForOneKidPreview",
                "groupExcelModule.totalBillForOneKid",
                "groupExcelModule.isContainAllBillOneKid",
                "groupExcelModule.loadingOneKid",
                "groupExcelModule.loadingBillPreview",
                "groupExcelModule.dataSearch",
                "groupExcelModule.exportParamForOneKid",
                "groupExcelModule.idKidList",
                "employeeSalaryNew.dataBillPreview",
                "employeeSalaryNew.billTableForOneKidPreview",
                "employeeSalaryNew.totalBillForOneKid",
                "employeeSalaryNew.isContainAllBillOneKid",
                "employeeSalaryNew.loadingOneKid",
                "employeeSalaryNew.loadingBillPreview",
                "employeeSalaryNew.dataSearch",
                "employeeSalaryNew.exportParamForEmployee",
                "employeeSalaryNew.idInfoList",
                "sinvoiceCustomerConfigStore.customerConfig",
                "sinvoiceCustomerConfigStore.hasData",
            ], // lấy state pdf trong vuex modules finance
        }),
    ],
});


